import moment from 'moment';
import momentTz from 'moment-timezone';
import { TIMEZONE_OPTIONS_MAP } from 'constants/index';

const convertTimeStampToDateTime = (
  timestamp: number,
  format = 'MM/DD/YYYY'
) => {
  return moment(timestamp).format(format);
};

/**
 * @param date - date in string format
 * @param timezone - timezone in string format
 * @returns date in UTC format
 */
export const dateTimeZoneToUTC = (date: string, timezone: string) => {
  const dateString = moment(date).format('YYYY-MM-DDTHH:mm');
  return moment.tz(dateString, TIMEZONE_OPTIONS_MAP[timezone]).utc().format();
};

/**
 * @param date - date in string format
 * @param timezone - timezone in string format
 * @returns date in timezone format
 */
export const utcToTimeZone = (date: string, timezone: string) => {
  const tz =
    TIMEZONE_OPTIONS_MAP[timezone as keyof typeof TIMEZONE_OPTIONS_MAP];
  if (!tz) return null;
  const timeZoneDate = momentTz.utc(date).tz(tz);
  const currentDate = timeZoneDate.date();
  const month = timeZoneDate.month() + 1;
  const year = timeZoneDate.year();
  const hour = timeZoneDate.hour();
  const minute = timeZoneDate.minute();
  return moment(
    `${year}-${month}-${currentDate} ${hour}:${minute}`,
    'YYYY-MM-DD HH:mm'
  );
};

/**
 * Convert UTC date to local time format with timezone
 * @param date - date in string format
 * @param timezone - timezone in string format
 * @returns date in local time format
 */
export const utcToLocalTime = (date: string, timezone: string) => {
  if (!date || !timezone) return '';
  const dateTimeWithTimezone = utcToTimeZone(date, timezone);
  return dateTimeWithTimezone
    ? moment(dateTimeWithTimezone).format('MM/DD/YYYY hh:mm a').toUpperCase()
    : '';
};

export default convertTimeStampToDateTime;
